import { createSelectorsFromModel } from '@/helpers/redux';

const model = {
    ticketData: null,
    loading: false,
    error: null,
};

export const selectors = createSelectorsFromModel(
    (state) => state.flights.view,
    model,
);

export default model;
